import { Select, Option } from 'src/components/PulseUI';
import { DataIssueTypes } from './types';

interface DataIssueTypeSelectorProps {
  issueType: DataIssueTypes;
  onChange?: (value: string) => void;
}

const DataIssueTypeSelector = ({
  issueType,
  onChange,
}: DataIssueTypeSelectorProps) => {
  const menuItems = [
    { value: 'address', label: 'Address or Location' },
    { value: 'phone', label: 'Phone' },
    { value: 'email', label: 'Email' },
    { value: 'other', label: 'Other' },
  ].filter(Boolean);

  return (
    <div className="flex flex-col gap-2 mt-2" data-testid="data-issue-type-selector">
      <label htmlFor="issue-type-select" className="text-sm font-medium">
        Issue Type:
      </label>
      <Select
        id="issue-type-select"
        disabled={!onChange}
        value={issueType}
        onChange={(e, val) => (onChange ? onChange(String(val)) : null)}
        placeholder="Select an issue type"
        className="min-w-64 rounded-full"
        aria-label="Issue type"
        data-testid="issue-type-select"
      >
        {menuItems.map((item) => (
          <Option
            key={item.value}
            value={item?.value}
            data-testid={`issue-type-option-${item.value}`}
          >
            {item?.label}
          </Option>
        ))}
      </Select>
    </div>
  );
};

export { DataIssueTypeSelector };
